import { Link } from 'react-router'
import { Logo } from './logo'
import { MainCTAButtons } from './main-cta-buttons'

export function Header() {
	return (
		<header className="sticky top-0 z-50 border-b border-gray-200 bg-white/95 backdrop-blur-sm">
			<div className="mx-auto max-w-7xl px-6">
				<div className="flex items-center justify-between py-4 sm:py-5">
					<Link to="/" className="flex items-center gap-4">
						<Logo size="lg" />
						<div className="flex flex-col">
							<span className="text-lg leading-none font-bold">
								Task Sentry
							</span>
							<span className="text-primary text-xs leading-none font-medium">
								Privacy-First AI Focus
							</span>
						</div>
					</Link>

					<div className="flex items-center gap-3">
						<MainCTAButtons
							size="default"
							className="bg-primary hover:bg-primary/90 rounded-lg px-6 py-3 text-sm font-semibold text-white transition-all duration-200 hover:-translate-y-0.5"
						/>
					</div>
				</div>
			</div>
		</header>
	)
}
